import React from "react";
import Loader from "react-loader-spinner";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { checkTranslation, imageAddress, translate } from "../utils/useful";


class SearchGroupsModal extends React.Component {
    state = {
        data: [],
        selecteds: {}
    }

    componentDidMount() {
        // this.setState({ countries: countriesCode })
        this.initData()


    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.initData()
        }
    }

    showModal = () => {
        this.initData()
        this.modal.showModal()
    }

    hideModal = () => {
        this.setState({ selecteds: {}, data: [] })
        this.modal.hideModal()
    }


    initData = () => {
        // console.log("initData")
        // console.log(this.props.data)

        this.fetchData()
        this.setState({ selecteds: {} }, () => {
            if (Array.isArray(this.props.data)) {
                let selecteds = this.state.selecteds
                this.props.data.forEach(element => {
                    selecteds[element._id] = element//{ _id: element._id, removed: false, init: true }
                    selecteds[element._id].removed = false
                    selecteds[element._id].init = true
                    if (this.props.disableInitData) {
                        selecteds[element._id].disabled = true
                    }
                });
                // console.log(selecteds)

            }

        })
    }



    fetchData = () => {

        this.setState({ isLoadingData: true })
        let body = { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" }

        // console.log('this.props.variables   ',this.props.variables)
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    if (typeof body[key] == 'object') {
                        body[key] = body[key]._id
                    }
                }
            }
        }

        // console.log('body is',body)

        HttpServices.request('getConnectionGroups', body, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                return
            }
            // console.log(fetchResult)
            this.setState({ rawData: fetchResult.info, data: fetchResult.info })

        })
    }



    onDone = () => {
        // this.setState({ isLoadingPost: true })
        let selecteds = this.state.selecteds
        let final = []
        // console.log(selecteds)
        Object.values(selecteds).forEach(element => {
            // if (!element.init) {
            final.push(element)
            // }
        });

        // console.log(final)
        // return


        this.props.onDone(final, 'group', () => {
            // this.setState({ isLoadingPost: false })
        })
        this.modal.hideModal()

    }


    search(value) {
        let data = this.state.rawData
        data = data.filter(e => e.name?.toLowerCase().includes(value.toLowerCase()))
        this.setState({ data })
    }

    changeSelect = (prop) => {
        if (!this.state.selecteds[prop._id]?.disabled) {

            let selecteds = this.state.selecteds
            if (!selecteds[prop._id] || selecteds[prop._id].removed) {
                selecteds[prop._id] = { _id: prop._id, name: prop.name }
            } else {
                if (!selecteds[prop._id]?.owner && !this.props.mainAccess) {
                    delete selecteds[prop._id] //= { id: prop._id, fullname:prop.fullname,type:prop.type,username:prop.username,uType:'user',removed: true, init: false }
                }
            }

            // console.log(selecteds)

            this.setState({ selecteds })
        }
    }

    render() {
        return (

            <Modal ref={el => this.modal = el} maxWidth={400} noScroll={true} marginBottom={'5%'}>
                <div className="d-flex h-100 flex-column w-100 scroll-no-scrollbar" style={{ backgroundColor: '#fff', borderRadius: 8, position: 'relative', boxShadow: '0px 0px 50px #10101050' }}>
                    {/* <div className="w-100 p-0" > */}
                    <div className="w-100 bg-gray-1 position-sticky top-0 flexcb" style={{ zIndex: 1, padding: '7px 20px', borderRadius: '8px 8px 0px 0px' }}>

                        <p className="text-semibig text-bold color-dark-blue-1">{translate("ca.Hub Groups")}</p>

                        <div className="flexc">


                            <LoaderButton
                                onClick={() => this.onDone()}
                                isLoading={this.state.isLoadingPost}
                                text={translate("ca.Done")}
                                // background='linear-gradient(to right, #0796A9, #3391FF)'
                                // background='linear-gradient(to right, #0094FF, #6100FF)'
                                // icon={'/assets/icons/angle-right-white2.svg'}
                                backgroundImage='linear-gradient(45deg, #0094FF 0%, #6100FF 51%, #0094FF  100%)'
                                className={'button-interactive-1 py-1 px-2'}
                                language={this.props.language}
                            />
                            {/* <button onClick={() => this.onDone()} style={{ backgroundColor: '#ffffffde', borderRadius: 6 }}> */}
                            {/* <span className="text-normal px-2">Done</span> */}
                            {/* </button> */}



                            {/* <div className="cursor-pointer" onClick={() => this.modal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 14, height: 14 }} src="/images/close1.svg" alt="" />
                                </div> */}
                        </div>

                    </div>

                    {/* <div className="flex-1" style={{ overflow: 'auto', }} > */}
                    <div className="w-100 mb-0 px-4  py-1" style={{ backgroundColor: '#fff', borderBottom: '1px solid #eee' }}>
                        <input onChange={(e) => this.search(e.target.value)} placeholder={translate("ca.Search")} className="w-100" style={{ height: 30, fontSize: 15, background: 'transparent', borderRadius: 6, border: '0px solid #eee' }} />
                    </div>
                    <div className="w-100 flexc flex-column">
                        <div className="w-100 text-start  pb-2" style={{}} >
                            {this.state.data.map((prop, index) => {
                                let selected = (this.state.selecteds[prop._id] && this.state.selecteds[prop._id].removed != true)
                                let disabled = this.state.selecteds[prop._id]?.disabled

                                return (
                                    <div key={index} onClick={() => this.changeSelect(prop)} className="flexcb backHover pld-3 prd-4 pb-2 pt-2 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>
                                        {/* <div className='flexcc  mt-2 mb-2'> */}
                                        {/* <div>
                                                <img src={imageAddress(prop.image)} width="40px" style={{ borderRadius: 50, height: 40, objectFit: 'cover' }} />
                                            </div> */}
                                        {/* <p className="mrd-3 mt-1" style={{ fontSize: 20 }} >{prop.flag}</p> */}
                                        {/* <div> */}
                                        <p className="text-small text-semibold  ">{checkTranslation(prop.name)}</p>
                                        {/* <p className="text-smaller mx-2" style={{ color: '#789' }}>@{prop.username}</p> */}
                                        {/* <p className="text-smaller mx-2" style={{ color: '#789' }}>{prop.type}</p> */}
                                        {/* </div> */}
                                        {/* </div> */}

                                    </div>
                                )
                            })}
                        </div>
                        {this.state.data?.length === 0 && (
                            <div className="text-center mt-5">
                                {/* <img src="/images/target.svg" width="50px" /> */}
                                <p className="text-center text-small text-bold">{translate('found-nothing')}</p>
                                <p className="text-center text-smaller">{translate('ca.Change your search options')}</p>

                            </div>
                        )}
                    </div>
                    {/* </div> */}


                    {/* </div> */}
                </div>
            </Modal >
        );

    }
}


export default SearchGroupsModal;
